import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Product } from '../models/product';
import { ProductParams } from '../models/productParams';
import { ProductService } from '../_services/product.service';





@Injectable()
export class ProductListResolver implements Resolve<Product[]> {

    pageNumber = 1;
    pageSize = 5;
    productParams: ProductParams;

    constructor(private productService: ProductService, private router: Router) {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<Product[]> {

        console.log('resolver lista productos');
        
        const category = route.paramMap.get('category');

        console.log('category: ', category);
        

        this.productParams = new ProductParams(category, 0, 100000000, 0, 100000, 'minPrice');

        return this.productService.getProducts(category);
    }
}